// extracted by mini-css-extract-plugin
export var closeButton = "_5c-0";